<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row class="justify-center">
            <v-col
              cols="12"
              md="12"
            >
              <v-form
                ref="form_all"
                v-model="valid.all"
              >
                <v-tabs
                  centered
                  show-arrows
                >
                  <v-tab>
                    <v-icon left>
                      mdi-account-outline
                    </v-icon>Основные
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-account-outline
                    </v-icon>Реквизиты
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-account-outline
                    </v-icon>Контактная информация
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-account-outline
                    </v-icon>Файлы
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-account-outline
                    </v-icon>Атрибуты
                  </v-tab>
                  <v-tab v-if="service">
                    <v-icon left>
                      mdi-account-outline
                    </v-icon>Услуги
                  </v-tab>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="4"
                        md="2"
                      >
                        <v-text-field
                          v-model="form.created"
                          label="Дата создания"
                          type="date"
                          :disabled="true"
                        />
                      </v-col>
                      <v-col
                        cols="4"
                        md="2"
                      >
                        <v-text-field
                          v-model="form.number"
                          label="Системный номер"
                          :disabled="true"
                        />
                      </v-col>
                      <v-col
                        cols="4"
                        md="2"
                      >
                        <v-select
                          v-model="form.state"
                          label="Статус"
                          :items="select.state"
                          :disabled="view"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="form.name"
                          label="Наименование"
                          :disabled="view"
                        />
                        <v-select
                          v-model="form.operator"
                          label="Оператор платежа"
                          :items="select.operator"
                          item-value="id"
                          item-text="name"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-autocomplete
                          v-if="$store.state.access[17][5]"
                          v-model="form.client"
                          clearable
                          :filter="client_filter"
                          :items="select.clients"
                          item-value="id"
                          label="Поиск клиента"
                          :disabled="view"
                          :loading="search.client.loading"
                          :search-input.sync="search.client.text"
                          hide-no-data
                        >
                          <template v-slot:selection="{item}">
                            <v-list>
                              <v-list-item-content>
                                <v-list-item-title> {{ item.legal.name.short }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list>
                          </template>
                          <template v-slot:item="{item}">
                            <v-list two-line>
                              <v-list-item-content>
                                <v-list-item-title>  {{ item.legal.name.short }}</v-list-item-title>
                                <v-list-item-subtitle>ИНН: {{ item.legal.inn }} КПП: {{ item.legal.kpp }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col
                        cols="4"
                        md="2"
                      >
                        <v-text-field
                          v-model="form.icon"
                          label="Иконка"
                        />
                      </v-col>
                      <v-col
                        cols="4"
                        md="2"
                      >
                        <v-text-field
                          v-model="form.color"
                          label="Цвет"
                        />
                      </v-col>
                      <v-col
                        cols="4"
                        md="2"
                      >
                        <v-text-field
                          v-model="form.priority"
                          label="Приоритет"
                          type="number"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-expansion-panels>
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              Основные реквизиты
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-container class="py-0">
                                <v-row>
                                  <v-col cols="12">
                                    <v-text-field
                                      v-model="form.legal.name.full"
                                      name="legal_name_full"
                                      label="Полное наименование"
                                      :disabled="view"
                                      @input="legal_full_name_input"
                                    />
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
                                      v-model="form.legal.ogrn"
                                      name="legal_ogrn"
                                      label="ОГРН"
                                      :disabled="view"
                                      @input="legal_ogrn_input"
                                    />
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
                                      v-model="form.legal.ogrn_date"
                                      name="legal_ogrn_date"
                                      type="date"
                                      label="Дата выдачи ОГРН"
                                      :disabled="view"
                                    />
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
                                      v-model="form.legal.inn"
                                      name="legal_inn"
                                      label="ИНН"
                                      :disabled="view"
                                      @input="legal_inn_input"
                                    />
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
                                      v-model="form.legal.kpp"
                                      name="legal_kpp"
                                      label="КПП"
                                      :disabled="view"
                                    />
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    md="4"
                                  >
                                    <v-text-field
                                      v-model="form.legal.director.post"
                                      name="legal_director_post"
                                      label="Должность руководителя"
                                      :disabled="view"
                                    />
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    md="8"
                                  >
                                    <v-text-field
                                      v-model="form.legal.director.name"
                                      name="legal_director_name"
                                      label="ФИО Руководителя"
                                      :disabled="view"
                                    />
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              Банковские реквизиты
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="form.requisites.name"
                                    color="secondary"
                                    label="Наименование получателя"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="8"
                                >
                                  <v-text-field
                                    v-model="form.requisites.bank_name"
                                    name="bank"
                                    color="secondary"
                                    label="Банк"
                                    :disabled="view"
                                    @input="bank_input"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="form.requisites.bic"
                                    color="secondary"
                                    label="Бик"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="form.requisites.ks"
                                    color="secondary"
                                    label="К/с"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="form.requisites.rs"
                                    color="secondary"
                                    label="Р/с"
                                    :disabled="view"
                                  />
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-expansion-panels>
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              Адресные данные
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-row
                                v-for="(address,index) in form.addresses"
                                :key="'addr'+ index"
                              >
                                <v-col cols="12">
                                  <v-select
                                    v-model="address.type"
                                    :items="select.address_type"
                                    label="Тип адреса"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col cols="10">
                                  <v-text-field
                                    v-model="address.value"
                                    label="Адрес"
                                    :disabled="view"
                                    :name="'address' + String(address.index)"
                                    @input="adress_input(address)"
                                  />
                                </v-col>
                                <v-col cols="2">
                                  <v-icon @click="form.addresses = form.addresses.filter(a=>a!=address)">
                                    mdi-delete
                                  </v-icon>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                  <v-icon @click="form.addresses.push({value: '', type: 3})">
                                    mdi-plus
                                  </v-icon>
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              Контактные телефоны
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-row
                                v-for="(item, index) in form.phones"
                                :key="'ph' + index"
                              >
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="item.number"
                                    label="Номер телефона"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="5"
                                >
                                  <v-select
                                    v-model="item.type"
                                    label="Тип"
                                    class="purple-input"
                                    :disabled="view"
                                    :items="select.phone"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="2"
                                >
                                  <v-checkbox
                                    v-model="item.main"
                                    label="Основной номер"
                                    class="purple-input"
                                    :disabled="view"
                                    @change="()=> {if (item.main) for (let x in form.phones) form.phones[x].main = false; item.main = true; if (item.main && item.type == 1) data.phone = item.number}"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="1"
                                >
                                  <v-icon
                                    large
                                    @click="form.phones = form.phones.filter(a=>a!=item)"
                                  >
                                    mdi-minus
                                  </v-icon>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="9"
                                >
                                  <v-text-field
                                    v-model="item.comment"
                                    label="Комментарий"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="3"
                                >
                                  <v-checkbox
                                    v-model="item.sms"
                                    label="Согласие на СМС"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                  <v-icon @click="form.phones.push({})">
                                    mdi-plus
                                  </v-icon>
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-form>
                          <v-container class="py-0">
                            <v-card
                              class="elevation-1"
                              text
                            >
                              <v-progress-linear
                                class="ma-0"
                                color="secondary"
                                :indeterminate="loader.show"
                              />
                              <v-card-text>
                                <v-data-table
                                  hide-default-footer
                                  hide-default-header
                                  :items="form.files"
                                  :headers="table.headers"
                                  no-data-text="Нет данных для отображения"
                                >
                                  <template v-slot:item.save="{item}">
                                    <v-icon @click="getDoc(item)">
                                      mdi-content-save
                                    </v-icon>
                                  </template>
                                  <template v-slot:item.comment="{item}">
                                    <v-text-field
                                      v-model="item.comment"
                                      :disabled="loader.show || view"
                                      label="Описание"
                                    />
                                  </template>
                                </v-data-table>
                              </v-card-text>
                              <v-card-actions class="grey lighten-4">
                                <v-btn
                                  color="primary"
                                  text
                                  :disabled="loader.show || view"
                                  @click="$refs.upload.click()"
                                >
                                  Добавить файл
                                </v-btn>
                                <input
                                  ref="upload"
                                  type="file"
                                  style="display: none;"
                                  @change="upload"
                                >
                              </v-card-actions>
                            </v-card>
                          </v-container>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-data-table
                          :items="form.attributes_keys"
                          :headers="[
                            {value: 'key', text: 'Ключ', width: 150},
                            {value: 'value', text: 'Значение', width: 300},

                          ]"
                          :footer-props="datatable_footer"
                          no-data-text="Нет данных для отображения"
                        >
                          <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                            {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                          </template>
                          <template v-slot:item.key="{item}">
                            <v-text-field
                              v-model="item.key"
                              readonly
                              @input="settings_change(item)"
                            />
                          </template>

                          <template v-slot:item.value="{item}">
                            <v-text-field
                              v-model="form.attributes[item.key]"
                              @input="settings_change(item)"
                            />
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="attribute.key"
                          label="Ключ"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-btn
                          color="primary"
                          :disabled="!attribute.key"
                          @click="form.attributes_keys.push({
                            key: attribute.key
                          }), form.attributes[attribute.key] = '', attribute.key = null "
                        >
                          Добавить
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item v-if="service">
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-data-table
                          :items="form.services"
                          :headers="table.service.headers"
                          no-data-text="Нет данных для отображения"
                        >
                          <template v-slot:item.name="{item}">
                            <v-text-field
                              v-model="item.name"
                              label="Наименование"
                              @input="service_input(item)"
                            />
                          </template>
                          <template v-slot:item.description="{item}">
                            <v-textarea
                              v-model="item.description"
                              rows="1"
                              label="Введите назначение услуги"
                              :counter="210"
                              maxlength="210"
                              @input="service_input(item)"
                            />
                          </template>
                          <template v-slot:item.oktmo="{item}">
                            <v-text-field
                              v-model="item.oktmo"
                              label="ОКТМО"
                              :counter="8"
                              maxlength="8"
                              @input="service_input(item)"
                            />
                          </template>
                          <template v-slot:item.kbk="{item}">
                            <v-text-field
                              v-model="item.kbk"
                              label="КБК"
                              :counter="20"
                              maxlength="20"
                              @input="service_input(item)"
                            />
                          </template>
                          <template v-slot:item.icon="{item}">
                            <v-text-field
                              v-model="item.icon"
                              label="Иконка"
                              @input="service_input(item)"
                            />
                          </template>
                          <template v-slot:item.color="{item}">
                            <v-text-field
                              v-model="item.color"
                              label="Цвет"
                              @input="service_input(item)"
                            />
                          </template>
                          <template v-slot:item.priority="{item}">
                            <v-text-field
                              v-model="item.priority"
                              label="Приоритет"
                              type="number"
                              @input="service_input(item)"
                            />
                          </template>
                          <template v-slot:item.sum="{item}">
                            <v-text-field
                              v-model="item.sum"
                              type="number"
                              label="Сумма"
                              @input="service_input(item)"
                            />
                          </template>
                          <template v-slot:item.payee="{item}">
                            <v-text-field
                              v-model="item.payee"
                              label="Шлюз"
                              @input="service_input(item)"
                            />
                          </template>
                          <template v-slot:item.actions="{item}">
                            <v-icon
                              v-if="!item.new || item.new == false"
                              @click="form.services = form.services.filter(a=>a!=item)"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs>
              </v-form>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
            >
              <v-btn
                color="primary"
                large
                min-width="100"
                class="mr-5"
                @click="save_recipient"
              >
                Сохранить
              </v-btn>
              <v-btn
                color="secondary"
                large
                min-width="100"
                @click="$router.go(-1)"
              >
                Назад
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  import suggest from '../../../libs/suggestions.min.17.12.0.dev.js'
  export default {
    props: ['create', 'change', 'view', 'show', 'item', 'service'],
    data: () => ({
      valid: {
        all: true
      },
      attribute: {
        key: null
      },
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
      menu: {
        from: false,
        to: false
      },
      event: {
        items: [],
        form: {
          client: '',

        },
      },
      selected: {
      },
      info: {

      },
      loader: {
        show: false,
      },
      dialog: {
        event: {
          show: false,
          item: {},
        },

      },
      events: [

      ],
      table: {
        headers: [
          {
            text: '',
            value: 'save',
          },
          {
            text: 'Название',
            value: 'name',
          },
          {
            text: 'Описание',
            value: 'comment',
          },
        ],
        service: {
          headers: [
            { text: 'Наименование', value: 'name' },
            { text: 'Назначение', value: 'description' },
            { text: 'ОКТМО', value: 'oktmo' },
            { text: 'КБК', value: 'kbk' },
            { text: 'Иконка', value: 'icon' },
            { text: 'Цвет', value: 'color' },
            { text: 'Приоритет', value: 'priority' },
            { text: 'Сумма', value: 'sum' },
            { text: 'Шлюз', value: 'payee' },
            { text: 'Действия', value: 'actions' }
          ]
        }
      },
      tabs: [
        'Основные',
        'Реквизиты',
        'Контактная информация',
        'Файлы',
        'Атрибуты'
      ],
      data: {
        phone: '',
      },
      form: {
        services: [{
            new: true
          }],
        files: [],
        type: 0,
        legal: {
          name: {
            full: '',
            short: ''
          },
          ogrn: '',
          ogrn_date: '',
          inn: '',
          kpp: '',
          okved: [],
          director: {
            name: '',
            post: ''
          },
          tax: {
            authority: '',
            system: ''
          },
        },
        phones: [],
        addresses: [
          {
            index: 1,
            value: '',
            data: {
              postal_code: '',
              region_iso_code: '',
              region_with_type: '',
              city_with_type: '',
              street_with_type: '',
            },
            type: 1,
            suggestion: false,
          },
          {
            index: 2,
            value: '',
            data: {
              postal_code: '',
              region_iso_code: '',
              region_with_type: '',
              city_with_type: '',
              street_with_type: '',
            },
            type: 2,
            suggestion: false,
          },
        ],
        requisites: {
          name: '',
          rs: '',
          ks: '',
          bic: '',
        },
        attributes: {

        },
        attributes_keys: []
      },
      logs: [],
      dict: {
        recipient: {},
        insurer: {},
        phone: {
          1: 'Мобильный',
          2: 'Домашний',
        },
        address: {
          1: 'Юридический адрес',
          2: 'Фактический адрес',
        },
        file: {
          type: {
            0: 'Без типа',
            1: 'Слайдер в описании проекта',
            2: 'Договор поручительства',
            3: 'Документы проекта',
          },
        },
        event: {
          1: 'Звонок',
          2: 'SMS сообщение',
          3: 'Email сообщение',
          4: 'Встреча',
          5: 'Другое',
        },
        type: {}
      },
      select: {
        type: [
          {
            value: 0, text: 'Основной'
          },
          {
            value: 1, text: 'Монета'
          }
        ],
        state: [
          { value: 0, text: 'Доступен' },
          { value: 1, text: 'Недоступен' },
        ],
        operator: [],
        clients: []
      },
      suggestion: {
        address: false
      },
      search: {
        client: {
          loading: false,
          text: ''
        },
      },
    }),
    watch: {
      'search.client.text': function () {
        if (this.search.client.text) { this.load_clients(this.search.client.text) }
      },
    },
    mounted: function () {
      if (!this.$route.query.id) {
        this.form.created = moment().format('YYYY-MM-DD')
      }
      this.axios.post('/api/operator/list', { })
          .then(result => {
            if (!result.data.error) {
              this.select.operator = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
          })
      var id = this.$route.query.id
      if (id) {
        this.axios.post('/api/recipient/list', { id: id })
          .then(result => {
            if (!result.data.error) {
              this.form = result.data.data[0]
              if (this.form.created) this.form.created = moment(this.form.created).format('YYYY-MM-DD')
              this.form.requisites = this.form.requisites || {}
              this.form.legal = this.form.legal || {}
              this.form.legal.name = this.form.legal.name || {}
              this.form.legal.director = this.form.legal.director || {}
              this.form.addresses = this.form.addresses || []
              this.form.phones = this.form.phones || []
              this.form.attributes = this.form.attributes || {}
              this.form.attributes_keys = []
              for (const x in this.form.attributes) {
                this.form.attributes_keys.push({
                  key: x
                })
              }
              if (this.form.client) {
                this.load_clients_id(this.form.client)
              }
            }
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    methods: {
      service_input: function (item) {
        if (item.new == true) {
          item.new = false
          this.form.services.push({ new: true })
        }
      },
      client_filter: function (item, query, text) {
        if (item.legal && (item.legal.name.full).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.name.short).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.kpp).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.inn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.ogrn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      load_clients: function (text) {
        this.search.client.loading = true
        this.axios.post('/api/client/list', {
          search: text,
          limit: 10
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
      load_clients_id: function (id) {
        if (!id) return
        this.axios.post('/api/client/list', {
          id: id
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
      legal_short_name_input: function (item) {
        if (!this.suggestion.legal_requisites) {
          this.suggestion.legal_requisites = true
          $('[name=legal_name_short]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              try {
                console.log('data', data)
                this.form.legal.name.full = data.data.name.full_with_opf
                this.form.legal.name.short = data.data.name.short_with_opf
                this.form.legal.inn = data.data.inn
                this.form.legal.kpp = data.data.kpp
                this.form.legal.ogrn = data.data.ogrn
                this.form.legal.ogrn_date = data.data.ogrn_date ? moment(new Date(data.data.ogrn_date)).format('YYYY-MM-DD') : ''
                this.form.legal.okved = data.data.okveds || [data.data.okved]
                this.form.legal.director = {}
                if (data.data.management) {
                  this.form.legal.director.name = data.data.management.name
                  this.form.legal.director.post = data.data.management.post
                }
                if (data.data.address) {
                  this.form.addresses =
                    [{
                    value: data.data.address.unrestricted_value,
                    data: data.data.address.data,
                    type: 1
                  }]
                }
                this.form.tax = {}
                console.log('data_end', this.form)
              } catch (err) {
                console.log('err', err)
              }
            },
          })
        }
      },
      legal_full_name_input: function (item) {
        if (!this.suggestion.legal_requisites) {
          this.suggestion.legal_requisites = true
          $('[name=legal_name_full]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.legal.name.full = data.data.name.full_with_opf
              this.form.legal.name.short = data.data.name.short_with_opf
              this.form.legal.inn = data.data.inn
              this.form.legal.kpp = data.data.kpp
              this.form.legal.ogrn = data.data.ogrn
              this.form.legal.ogrn_date = data.data.ogrn_date ? moment(new Date(data.data.ogrn_date)).format('YYYY-MM-DD') : ''
              this.form.legal.okved = data.data.okveds || [data.data.okved]
              this.form.legal.director = {}
              if (data.data.management) {
                this.form.legal.director.name = data.data.management.name
                this.form.legal.director.post = data.data.management.post
              }
               if (data.data.address) {
                  this.form.addresses =
                    [{
                    value: data.data.address.unrestricted_value,
                    data: data.data.address.data,
                    type: 1
                  }]
                }
              this.form.tax = {}
            },
          })
        }
      },
      legal_inn_input: function (item) {
        if (!this.suggestion.legal_requisites) {
          this.suggestion.legal_requisites = true
          $('[name=legal_inn]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.legal.name.full = data.data.name.full_with_opf
              this.form.legal.name.short = data.data.name.short_with_opf
              this.form.legal.inn = data.data.inn
              this.form.legal.kpp = data.data.kpp
              this.form.legal.ogrn = data.data.ogrn
              this.form.legal.ogrn_date = data.data.ogrn_date ? moment(new Date(data.data.ogrn_date)).format('YYYY-MM-DD') : ''
              this.form.legal.okved = data.data.okveds || [data.data.okved]
              this.form.legal.director = {}
              if (data.data.management) {
                this.form.legal.director.name = data.data.management.name
                this.form.legal.director.post = data.data.management.post
              }
              this.form.tax = {}
            },
          })
        }
      },
      legal_ogrn_input: function (item) {
        if (!this.suggestion.legal_requisites) {
          this.suggestion.legal_requisites = true
          $('[name=legal_ogrn]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.legal.name.full = data.data.name.full_with_opf
              this.form.legal.name.short = data.data.name.short_with_opf
              this.form.legal.inn = data.data.inn
              this.form.legal.kpp = data.data.kpp
              this.form.legal.ogrn = data.data.ogrn
              this.form.legal.ogrn_date = data.data.ogrn_date ? moment(new Date(data.data.ogrn_date)).format('YYYY-MM-DD') : ''
              this.form.legal.okved = data.data.okveds || [data.data.okved]
              this.form.legal.director = {}
              if (data.data.management) {
                this.form.legal.director.name = data.data.management.name
                this.form.legal.director.post = data.data.management.post
              }
              this.form.tax = {}
            },
          })
        }
      },
      bank_input: function (item) {
        if (!this.suggestion.requisites) {
          this.suggestion.requisites = true
          $('[name=bank]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.requisites.bank_name = data.data.name.full || data.data.name.payment
              this.form.requisites.bic = data.data.bic
              this.form.requisites.ks = data.data.correspondent_account
            },
          })
        }
      },
      adress_input: function (item) {
        if (!item.suggestion) {
          console.log('[name=address' + String(item.index) + ']')
          item.suggestion = true
          $('[name=address' + String(item.index) + ']').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              item.value = data.unrestricted_value
              item.data = data.data
              console.log(item)
            },
          })
        }
      },
      upload: function (event) {
        const files = event.target.files
        if (files[0]) {
          this.loader.show = true
          const data = new FormData()
          data.append('file', files[0])
          this.axios
            .post('/api/common/file/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              } else {
                for (const x in response.data.data) {
                  this.form.files.push(response.data.data[x])
                }

                console.log(this.form.files)
              }
              this.loader.show = false
            })
            .catch(error => {
              console.log(error)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              this.loader.show = false
            })
        }
      },
      settings_change: function (item) {
        console.log(item)
        if (item.new) {
          item.new = false
          this.form.settings.push({
            new: true,
            type: 0,
            values: []
          })
        }
      },
      get_color: function (item, type) {
        return 'white'
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format_contract: function (number, date) {
        return number + '/' + moment(date).format('DDMM')
      },
      getDoc: function (item) {
        console.log(item)
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file/get',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      open_file: function (id, item) {
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: id,
            name: 'id',
          })
        )
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item,
            name: 'name',
          })
        )
        form.appendTo('body').submit()
      },
      adress_input: function (item) {
        if (!this.suggestion.address) {
          console.log('[name=address]')
          this.suggestion.address = true
          $('[name=address]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              this.form.address = data.unrestricted_value
              this.form.address_data = data.data
            },
          })
        }
      },
      save_recipient: function () {
        this.form.services = this.form.services.filter(a => !a.new || a.new == false)
        let url = '/api/recipient/create'
        if (this.service) {
          url = '/api/recipient/create/service'
        }
        if (this.form.id) {
          url = '/api/recipient/save'
        }
        this.axios.post(url, this.form)
            .then(result => {
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Данные успешно сохранены')
                this.$router.go(-1)
              } else {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
      },
    },
  }
</script>
